export default __webpack_public_path__ + "static/media/black-polygon-measure-icon.158d0d6b.svg";